__turbopack_context__.v({
  "addBtn": "speakersTable-module-scss-module__hnhmna__addBtn",
  "email": "speakersTable-module-scss-module__hnhmna__email",
  "headerTable": "speakersTable-module-scss-module__hnhmna__headerTable",
  "inputContainer": "speakersTable-module-scss-module__hnhmna__inputContainer",
  "landingTableTitle": "speakersTable-module-scss-module__hnhmna__landingTableTitle",
  "removeBtn": "speakersTable-module-scss-module__hnhmna__removeBtn",
  "speakerField": "speakersTable-module-scss-module__hnhmna__speakerField",
  "speakerTableContainer": "speakersTable-module-scss-module__hnhmna__speakerTableContainer",
});
